/**
 * 后端多用 datetime.utcnow() 存库，isoformat() 又不带时区。
 * 浏览器会把无时区 ISO 当成「本地时间」，在中国正好偏 8 小时。
 * 无 Z / 无偏移的时间一律按 UTC 解析，再按 Asia/Shanghai 展示。
 */

export function parseServerDate(value) {
  if (!value) return null;
  if (value instanceof Date) {
    return Number.isNaN(value.getTime()) ? null : value;
  }
  const raw = String(value).trim();
  if (!raw) return null;

  if (/[zZ]|[+-]\d{2}:?\d{2}$/.test(raw)) {
    const d = new Date(raw);
    return Number.isNaN(d.getTime()) ? null : d;
  }

  const normalized = raw.includes("T") ? raw : raw.replace(" ", "T");
  const d = new Date(`${normalized}Z`);
  return Number.isNaN(d.getTime()) ? null : d;
}

export function formatBeijingDateTime(value, options = {}) {
  const d = parseServerDate(value);
  if (!d) return "";
  return d.toLocaleString("zh-CN", {
    timeZone: "Asia/Shanghai",
    ...options,
  });
}

/**
 * @param {string} [justNow="刚刚"]
 * @param {string} [activeSuffix=""] 例如「活跃」→「刚刚活跃」
 */
export function formatRelativeTime(
  value,
  { justNow = "刚刚", activeSuffix = "" } = {}
) {
  const d = parseServerDate(value);
  if (!d) return "";
  const diffSec = Math.floor((Date.now() - d.getTime()) / 1000);
  if (diffSec < 60) return `${justNow}${activeSuffix}`;
  if (diffSec < 3600) return `${Math.floor(diffSec / 60)} 分钟前${activeSuffix}`;
  if (diffSec < 86400) return `${Math.floor(diffSec / 3600)} 小时前${activeSuffix}`;
  if (diffSec < 86400 * 7) return `${Math.floor(diffSec / 86400)} 天前${activeSuffix}`;
  return formatBeijingDateTime(d, {
    month: "numeric",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}
